import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header className="relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 absolute top-0 left-0 right-0 z-10">
        <div className="flex justify-between items-center h-16 lg:h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <h1 className="text-2xl lg:text-3xl font-bold text-[#08206B] cursor-pointer" onClick={() => navigate("/")}>
              Kazi Agency
            </h1>
          </div>

          {/* Auth Buttons - Desktop */}
          <div className="hidden md:flex items-center space-x-4">
            <button onClick={() => navigate("/sign-in")} className="px-6 py-2 bg-[#56B22F] text-white rounded-lg hover:bg-[#4a9c28] transition-colors">
              Sign In
            </button>
            <button onClick={() => navigate("/sign-up")} className="px-6 py-2 bg-[#08206B] border border-gray-300 text-white rounded-lg hover:bg-[#23205c] transition-colors">
              Sign Up
            </button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-600 hover:text-gray-900 p-2"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4">
              <a href="#features" className="text-gray-700 hover:text-[#56B22F] transition-colors">
                Features
              </a>
              <a href="#how-it-works" className="text-gray-700 hover:text-[#56B22F] transition-colors">
                How It Works
              </a>
              <a href="#testimonials" className="text-gray-700 hover:text-[#56B22F] transition-colors">
                Testimonials
              </a>
              <a href="#faqs" className="text-gray-700 hover:text-[#56B22F] transition-colors">
                FAQs
              </a>
              <a href="#contact" className="text-gray-700 hover:text-[#56B22F] transition-colors">
                Contact
              </a>
              <div className="flex flex-col space-y-2 pt-4">
                <button className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors">
                  Login
                </button>
                <button className="px-6 py-2 bg-[#56B22F] text-white rounded-lg hover:bg-[#4a9c28] transition-colors">
                  Sign up
                </button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header; 